import React, { FunctionComponent } from "react";
import { Card  } from "@mui/material";
import { CardContent } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { Rank } from "../../models";

interface RankCardProps {
  rank: Rank;
}

const RankCard: FunctionComponent<RankCardProps> = ({ rank }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography>{t("lookup.rankCard.title")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" component="h2">
              {rank.name || ""}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RankCard;
